<template>
  <ChartBase title="Top Products" :loading="loading">
    <PieChart
      class="chart-thirty-day-top-products"
      ref="pie"
      :chart-options="chartOptions"
      :chart-data="chartData"
    />
  </ChartBase>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import {
  NAMED_COLORS,
  CHART_COLORS,
  PieChartOptions,
} from '@/constants/ChartOptions'
import ChartBase from '@/components/ChartBase.vue'

import { Pie as PieChart } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from 'chart.js'

export default {
  name: 'ChartThirtyDayTopProductsByRevenue',
  components: {
    ChartBase,
    PieChart,
  },
  data() {
    return {
      loading: true,
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: PieChartOptions,
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopId']),
  },

  methods: {
    ...mapActions('shop', ['getChartThirtyDayTopProductsByRevenue']),
    initPieChart() {
      ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

      ChartJS.overrides.pie = { plugins: PieChartOptions.plugins }
    }, // initPieChart
  },
  async mounted() {
    await this.initPieChart()

    const {
      data: chartData,
    } = await this.getChartThirtyDayTopProductsByRevenue()

    this.chartData.labels = chartData.labels
    let nonGrayColors = NAMED_COLORS.filter(
      (color) => color !== CHART_COLORS.grey
    )

    let count = 0
    let colorizedData = chartData.datasets.map(function(dataSet) {
      // create an array that's one item short of the amount of labels
      // then we add "grey" as the last color, to sync with the "Other" label
      let colors = Array.from({ length: dataSet.data.length - 1 }, () => {
        return nonGrayColors[count++ % (nonGrayColors.length - 1)]
      })
      colors.push(CHART_COLORS.grey)

      return {
        ...dataSet,
        backgroundColor: colors,
      }
    })
    this.chartData.datasets = colorizedData
    this.loading = false
  },
}
</script>
